var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-list"},_vm._l((_vm.navList),function(item,index){return _c('div',{key:index,class:`nav-item ${_vm.activeClass(item.path)}`,on:{"click":function($event){return _vm.goto(item.path)}}},[_vm._v(" "+_vm._s(_vm.$t(item.name))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }